import { MainViewController } from 'fragments/main/interfaces';

export const useMainController = (): MainViewController => {
    return {};
};
